export const components = () => ([
  // layout
  {
    tag: 'row',
    name: 'LayoutRow',
  },
  {
    tag: 'column-group',
    name: 'LayoutColumns',
  },
  {
    tag: 'tabs',
    name: 'LayoutTabs',
  },
  // elements
  {
    tag: 'buttons',
    name: 'ElementsButtons',
  },
  {
    tag: 'divider',
    name: 'ElementsDivider',
  },
  {
    tag: 'heading',
    name: 'ElementsHeading',
  },
  {
    tag: 'html',
    name: 'ElementsHtmlCode',
  },
  {
    tag: 'text',
    name: 'ElementsText',
  },
  // media
  {
    tag: 'banner',
    name: 'MediaBanner',
  },
  {
    tag: 'image',
    name: 'MediaImage',
  },
  {
    tag: 'map',
    name: 'MediaMap',
  },
  {
    tag: 'slider',
    name: 'MediaSlider',
  },
  {
    tag: 'video',
    name: 'MediaVideo',
  },
  // content
  {
    tag: 'block',
    name: 'ContentBlock',
  },
  {
    tag: 'dynamic_block',
    name: 'ContentDynamicBlock',
  },
  {
    tag: 'products',
    name: 'ContentProducts',
  }
]);

export default components;
